import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuService } from '../../_service/menu/menu.service';

@Component({
    selector: 'app-dn-user-menu',
    templateUrl: './dn-user-menu.component.html',
    styleUrls: ['./dn-user-menu.component.scss']
})

export class DnUserMenuComponent implements OnInit,OnDestroy {
    ngOnDestroy(): void {
    }
    menu: any[];

    constructor(
        private _menuService: MenuService,
    ) {
       
    }
    ngOnInit() {
        this.menu = this._menuService.getUserMenu();
    }

    readState() {

    }
}
